/** @jsx jsx */
import { jsx, css } from '@compiled/react';
import * as grid from '@helpcenter/styles/src/grid';
import { NoteBackground } from 'view/layout/paper/styled';

const anonymousStyles = css({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/ensure-design-token-usage
    marginTop: `-${grid.multiple(15).unitless}px`,
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    maxWidth: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    minHeight: `${grid.multiple(52).unitless}px`,
    alignSelf: 'flex-start',
    '@media (min-width: 0em) and (max-width: 30em)': {
        minHeight: '100%',
        marginTop: '0',
    },
});
export const HubAnonymousLayout = ({ children }: { children: React.ReactNode }) => (
    <div css={anonymousStyles}>
        <NoteBackground>{children}</NoteBackground>
    </div>
);
